import { type ContextProviderComponent, createContext, createEffect, untrack } from "solid-js";
import { createStore } from "solid-js/store";
import { initializedContext } from "../utils/initializedUtil";
import type CustomerId from "./CustomerId";
import type CustomerUid from "./CustomerUid";

export const PRODUCT_FEATURES = [
  "HOOKS",
  "WEBHOOKS",
  "SENDING_DOMAIN",
  "SINGLE_SIGN_ON",
  "FORM_VARIABLES",
  "TASK_LOCATION",
  "MANUAL_DATASOURCES",
  "AUTOMATIC_DATASOURCES",
  "ADVANCED_USER_MANAGEMENT",
];
export type ProductFeature = (typeof PRODUCT_FEATURES)[number];

export type DateFormat = "DDMMYYYY" | "YYYYMMDD" | "MMDDYYYY";

export type Customer = {
  id: CustomerUid;
  customerId: CustomerId;
  name: string;
  unlockedFeatures: ProductFeature[];
  createdOn: Date;
  logoAssetId?: string;
  settings: {
    dateFormat: DateFormat;
    segment: string;
    otherSegment?: string;
  };
  meta: {
    deleteOn?: Date;
  };
};

type State = Customer;
const StateContext = createContext<State>();

export const CustomerProvider: ContextProviderComponent<Customer> = (props) => {
  const [store, setStore] = createStore<Customer>(untrack(() => props.value));
  createEffect(() => {
    setStore(props.value);
  });

  return <StateContext.Provider value={store}>{props.children}</StateContext.Provider>;
};

export const useCustomerState = () => initializedContext(StateContext, "useCustomerState", "CustomerProvider");
